import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'

type CardPejabatPenilaiKinerjaProps = {
  name?: string | undefined
}
const CardPejabatPenilaiKinerja = ({
  name,
}: CardPejabatPenilaiKinerjaProps) => {
  return (
    <SimpleCard className="flex flex-col gap-4 p-6 max-w-96 grow">
      <div className="flex flex-col gap-1">
        <Text variant="heading-sm">Pejabat Penilai Kinerja Anda</Text>
        <Text>
          {name || 'Tidak ditemukan. Mohon hubungi Dinas Pendidikan setempat.'}
        </Text>
      </div>

      <Text color="subdued" className="flex gap-2">
        <Icon color="inherit">info_outlined</Icon>

        <span>
          <span className="font-bold">Tim Kinerja</span> juga akan hadir untuk
          membantu Pejabat Penilai Kinerja.
        </span>
      </Text>

      {/** TODO: set later */}
      <a href={'#'} target="_blank" rel="noreferrer">
        <Text variant="body-sm-bold" color="informational">
          Ke Pusat Informasi
        </Text>
      </a>
    </SimpleCard>
  )
}

export default CardPejabatPenilaiKinerja
